import React from 'react';
import { ConfigProvider, type ThemeConfig } from 'antd';

import { tokens } from './tokens';

type ConfigProviderLocale = React.ComponentProps<typeof ConfigProvider>['locale'];

export type UiProviderProps = {
    children?: React.ReactNode;
    /** Override or extend the package tokens for a subtree. Defaults to the owned brand tokens. */
    theme?: ThemeConfig;
    /** AntD locale, forwarded to the underlying ConfigProvider (e.g. the app's i18n locale). */
    locale?: ConfigProviderLocale;
};

/**
 * Theme provider for `@ui/components`. Wraps children in AntD's `ConfigProvider`
 * with the package-owned {@link tokens} and `cssVar: true` (so tokens emit CSS
 * variables — the form Storybook and design-sync consume). Every story is
 * wrapped in `<UiProvider>` via the global Storybook decorator, and any
 * standalone usage of these primitives should be wrapped the same way.
 */
const UiProvider = ({ children, theme = tokens, locale }: UiProviderProps) => (
    <ConfigProvider theme={{ ...theme, cssVar: true }} locale={locale}>
        {children}
    </ConfigProvider>
);

export default UiProvider;
